import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';
import { Icon } from '../Icon';

interface WrapperProps {
  $noMargin?: boolean;
  $disabled?: boolean;
  $iconPrefix?: boolean;
}

export const Wrapper = styled.div<WrapperProps>`
  --text-size: ${(props) => props.theme.font.size.xsmall};
  --line-height: ${(props) => props.theme.font.lineHeight.main};

  margin-top: ${size(0.5)};
  font-size: var(--text-size);
  line-height: var(--line-height);
  color: var(--c-text-muted);

  ${({ $noMargin }) =>
    $noMargin &&
    css`
      margin-top: 0;
    `}

  ${({ $disabled }) =>
    $disabled &&
    css`
      opacity: 0.37;
    `}

  ${({ $iconPrefix }) =>
    $iconPrefix &&
    css`
      --icon-size: 1.125em;

      display: flex;
      align-items: flex-start;
      gap: ${size(0.5)};

      ${Icon} {
        flex-shrink: 0;
        font-size: var(--icon-size);
        margin-top: calc((var(--icon-size) - var(--text-size) * var(--line-height)) / -2);
      }
    `}
`;
